export type UsCoatLengthOption = {
  value: UsCoatLengthEnum;
  shortLabel: string;
  longLabel: string;
};

export const US_COAT_LENGTH_OPTIONS: UsCoatLengthOption[] = [
  {
    value: 'Short',
    shortLabel: 'S',
    longLabel: 'Short (S)',
  },
  {
    longLabel: 'Regular (R)',
    value: 'Regular',
    shortLabel: 'R',
  },
  {
    longLabel: 'Long (L)',
    value: 'Large',
    shortLabel: 'L',
  },
];

export const US_COAT_LENGTH_VALUE_TO_OPTION = US_COAT_LENGTH_OPTIONS.reduce(
  (acc, option) => ({ ...acc, [option.value]: option }),
  {} as Record<string, UsCoatLengthOption>
);

export const HALF_SIZE_NUMBER_REGEX = /^\d+(\.5)?$/;
export const ONLY_DIGITS_REGEX = /^\d+$/;

export const WHOLE_NUMBER_ERROR_MESSAGE = 'Please enter a whole number';
